module.exports = "/app/main/img/extra-luggage-v2.ecd5f936.png";